import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  margin-left: 15px;
  background: ${(props) => props.theme.colors?.greys.lightest};
  box-shadow: ${(props) => props.theme.shadows.short};
  border-radius: ${(props) => props.theme.borders?.radius.weak};
`;
